import utils from 'utils'
import billTemplate from './view/billModel.html'

class riskWarningModal {
    constructor($scope, httpRequest, $uibModal, logger, sweetalert, $filter, $uibModalInstance, $stateParams, items1) {
        $scope.value = items1.value
        $scope.invoiceList = items1.invoiceList
        $scope.invoiceList.forEach((item,index) => {
            item.uid = index
        })
        $scope.uid = items1.invoiceList.length>0?$scope.invoiceList[0].uid:''
        $scope.data = $scope.invoiceList[0]

        httpRequest.get_dictByTypeArr(['inv_type'])
            .then((res) => {
                $scope.dictData = res.data.value
            })
        $scope.previewTheBill = (item) => {
            $uibModal
                .open({
                    template: billTemplate,
                    controller: 'fullEleInvoiceDetailCtrl',
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-hg750',
                    resolve: {
                        items1() {
                            return item
                        },
                    },
                })
                .result.then(
                () => {},
                () => {}
            )
        }
        // 关闭
        $scope.chooseInv = function (item) {
            $scope.uid = item.uid
            $scope.data = item
        }
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
        $scope.manualContact = function () {
            if (!$scope.data) return logger.logError('请选择发票进行关联')
            httpRequest.post_makeAssociations($scope.data).then((res) => {
                $uibModalInstance.close('关联')
            })
        }
        $scope.ok = function () {
            $uibModalInstance.close($scope.data)
        }
    }
}

riskWarningModal.$inject = ['$scope', 'httpRequest', '$uibModal', 'logger', 'sweetalert', '$filter', '$uibModalInstance', '$stateParams', 'items1']
export default riskWarningModal



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/fullEleInvoice/riskWarningModal.js